exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-container[data-v-7efe54d5] {\n  padding: 20px;\n}\n", ""]);

// exports
